// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e018f68c","453":"ab62bfb3"}[chunkId] + ".chunk.js";
};